import { onMounted, onUnmounted } from 'vue'

// Keeps the screen awake for as long as the app is open (kiosk tablets must
// not lock or dim mid-shift). The OS may still refuse or drop the lock (low
// battery, an unsupported browser, or the user manually locking the device),
// so this cannot be an absolute guarantee — only best-effort via the
// standard Wake Lock API. The lock is released by the browser whenever the
// tab is hidden, so it must be re-acquired on visibilitychange.
export function useWakeLock() {
    let sentinel: WakeLockSentinel | undefined

    const request = async () => {
        if (!('wakeLock' in navigator) || document.visibilityState !== 'visible') return

        try {
            sentinel = await navigator.wakeLock.request('screen')
        } catch {
            // Ignored: e.g. no user gesture yet, or the platform refused the lock.
        }
    }

    const onVisibilityChange = () => {
        if (document.visibilityState === 'visible') request()
    }

    onMounted(() => {
        request()
        document.addEventListener('visibilitychange', onVisibilityChange)
    })

    onUnmounted(() => {
        document.removeEventListener('visibilitychange', onVisibilityChange)
        sentinel?.release()
    })
}
